"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M20.5 36a15.493 15.493 0 0 1 10.4-14.622 18.66 18.66 0 0 0 1.689-7.465c0-7-3.419-10.3-8.585-10.3s-8.683 3.456-8.683 10.3a17.633 17.633 0 0 0 3.253 9.86 2.038 2.038 0 0 1 .455 1.253v2.794a1.888 1.888 0 0 1-1.549 1.946C6.182 30.881 4 38.96 4 42c0 .338.037 1.667.06 2h18.683a15.405 15.405 0 0 1-2.243-8z" }),
  React.createElement("path", { d: "M36 24.1A11.9 11.9 0 1 0 47.9 36 11.9 11.9 0 0 0 36 24.1zm8 13.4a.5.5 0 0 1-.5.5H38v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V38h-5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H34v-5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V34h5.5a.5.5 0 0 1 .5.5z" })
);

